import React from 'react';
import { IconType } from 'react-icons';
import styled from 'styled-components';

const IconWrapper = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
`;

interface IconProps {
  icon: IconType;
  size?: number;
  color?: string;
}

export const Icon: React.FC<IconProps> = ({ icon: IconComponent, size = 20, color }) => {
  const IconElement = IconComponent as React.ComponentType<{ size?: number; color?: string }>;
  return (
    <IconWrapper>
      <IconElement size={size} color={color} />
    </IconWrapper>
  );
}; 